<template>
  <div class="skeleton" :style="style">
    <div v-if="!loading && error" class="skeleton-wrapper">
      <div class="skeleton-face"></div>
      <div class="skeleton-txt">
        加载失败
        <span class="skeleton-click" @click="$emit('retry')">
          点击刷新
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const { width = '100%', height = '100%' } = this.config
      return {
        width: width.includes('%') ? width : parseFloat(width) + 'px',
        height: height.includes('%') ? height : parseFloat(height) + 'px'
      }
    }
  }
}
</script>
